export const hqTab = 'HQ';
export const retailTab = 'Retail';
